import { HStack, Text, VStack } from '@chakra-ui/react';
import { TechSpecs as TechSpecsType } from '@/entities/product';

interface TechSpecsProps {
  techSpecs: TechSpecsType;
}

const TechSpecs = ({ techSpecs }: TechSpecsProps) => (
  <VStack spacing={2}>
    {Object.entries(techSpecs).map(([key, value]) => (
      <HStack
        key={key}
        align='start'
        justify='space-between'
        width='full'
      >
        <Text
          color='gray.700'
          fontWeight='semibold'
          textTransform='capitalize'
        >
          {key}:
        </Text>
        <Text color='gray.600'>{value}</Text>
      </HStack>
    ))}
  </VStack>
);

export default TechSpecs;
